module.exports = __webpack_public_path__ + "img/4.5267d6ec.jpg";